<template>
    <div class="main-navigation"  :class="getMainNavClasses">
      <div class="content" v-if="windowWidth > 992">
       
        <div class="nav-left">
          <router-link to="/"><img src="../../assets/taberna-logo.png"></router-link>
          <li><router-link to="/pizze">PIZZE</router-link></li>
          <li><router-link to="/slovenski-piscanec">SLOVENSKI PIŠČANEC</router-link></li>
          <li><router-link to="/ostale-jedi">OSTALE JEDI</router-link></li>
          <li><router-link to="/cenik">CENIK</router-link></li>
          <li><router-link to="/cenik-za-dostavo">CENIK ZA DOSTAVO</router-link></li>
          <li><router-link to="/malice">MALICE</router-link></li>
        </div>
        <div class="nav-right">
          <Button href="tel:+38618394752">NAROČI DOSTAVO NA: 01/839-47-52</Button>
        </div>
      </div>

       <div class="content-mobile" v-if="windowWidth < 992">
          <div class="right">
            <div v-on:click="isHidden = !isHidden" class="hamburger"></div>
          </div>
        </div>
        <transition name="fade">
        <div class="menu-opened" v-show="!isHidden">
            <router-link to="/"><img src="../../assets/taberna-logo.png"></router-link>
          <li><router-link to="/pizze">PIZZE</router-link></li>
          <li><router-link to="/slovenski-piscanec">SLOVENSKI PIŠČANEC</router-link></li>
          <li><router-link to="/ostale-jedi">OSTALE JEDI</router-link></li>
          <li><router-link to="/cenik">CENIK</router-link></li>
          <li><router-link to="/cenik-za-dostavo">CENIK ZA DOSTAVO</router-link></li>
          <li><router-link to="/malice">MALICE</router-link></li>
          </div>
          </transition>

    </div>
</template>


<style lang="scss">   
@import 'navbar.scss';

.main-navigation {
  transition:.3s;
}

.scroll-down {
background-color:white;
margin-top:0;
box-shadow: 0px 25px 88px #0e0e0e40;

.nav-left {
  li {
    a {
      color:black;
    }
  }
}

}
</style>

<script>
import Button from "@/components/Button/Button";
 
export default {
  components: {
    Button
  },
    data: () => ({
      windowWidth: window.innerWidth,
      isHidden: true,
      scrollingUp: false,
      scrollingDown: false,
      prevScrollpos: window.pageYOffset
    }),
    mounted() {
    window.onresize = () => {
        this.windowWidth = window.innerWidth
      }
      this.handleScroll();
    },
    computed: {
      getMainNavClasses() {
      return {
        'scroll-up': this.scrollingUp,
        'scroll-down': this.scrollingDown,
      };
    },
    },
    methods: {
    scrollNow() {
      const currentScrollPos = window.pageYOffset;

      if (currentScrollPos == 0) {
        this.scrollingUp = false;
        this.scrollingDown = false;
        return;
      }

      if (currentScrollPos < 200) {
        this.scrollingUp = true;
        this.scrollingDown = false;
        return; // set offset here
      }

      if (currentScrollPos >= 200) {
        this.scrollingUp = false;
        this.scrollingDown = true;
        return; // set offset here
      }


      // if (this.prevScrollpos > currentScrollPos) {
      //   // up
      //   this.scrollingDown = false;
      //   this.scrollingUp = true;
      // } else {
      //   // down
      //   this.scrollingUp = false;
      //   this.scrollingDown = true;
      // }

      // this.prevScrollpos = currentScrollPos;
    },

    handleScroll() {
      let doScoll;

      window.onscroll = () => {
        clearTimeout(doScoll);
        doScoll = setTimeout(this.scrollNow, 20); // firing less scroll events
      };
    },
  },

  created() {
    this.handleScroll();
  },

  
  };
  
</script>
